import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './LimitToButton.scss';

export default function LimitToButton({
  disableLimit,
  limitTo = () => {
    Logger.error('limitTo something went wrong, value from ng is not a function');
  },
}) {
  return (
    <ButtonWithIcon
      id="limit"
      type="borderless"
      size="small"
      linkIconSize="s"
      sprite="Screenshot"
      layout="vertical"
      tabIndex="0"
      onClick={() => {
        limitTo();
      }}
      disabled={disableLimit}
      className="result-toolbar-limit-to-button e2e-limit"
      aria-label="Limit To">
      Limit To
    </ButtonWithIcon>
  );
}

LimitToButton.propTypes = {
  limitTo: PropTypes.func,
  disableLimit: PropTypes.bool,
};
